module.exports = ["CTServiceAPI", "AppConstants", "AppLanguage", "$q", "CommitmentModel", "ChannelRepository", function (CTServiceAPI, AppConstants, AppLanguage, $q, CommitmentModelFactory, ChannelRepository) {
    const _service = this,
        _cachedCommitments = {},
        _pageCache = {},
        _channel = ChannelRepository.get(AppConstants.CHANNEL_SUBMISSION.NAME);
    let _unfilteredCommitments = [];

    /**
     * Submit given data to the commitment module
     *
     * @param data
     */
    _service.submit = (data) => {
        // At first we expect the opt-in to be done already
        _service.optin_pending = false;

        if (AppLanguage !== false) {
            data.lang = AppLanguage.code;
            data.person.lang = AppLanguage.code;
        }

        let promise = CTServiceAPI.post(`/pages/${AppConstants.PAGE_ID}/commitments`, data);


        promise.then((submission) => {
            if (submission.is_new) {
                _channel.notify(AppConstants.CHANNEL_SUBMISSION.ACTION_SUBMITTED, CommitmentModelFactory(submission), 'item', 'commitment');
            }
        });

        return promise.then((submission) => {
            _service.optin_pending = submission.message === 'Opt-In-Pending';

            return submission.commitment_module_person || {
                // id       : submission.commitment_id,
                message: data.message,
                image: data.image,
                image_id: data.image_id,
                person: data.person,
                tags: (data.tags || []).splice(0),
            };
        });
    };

    /**
     * Check if the given data is valid
     *
     * @param data
     * @return {Array|boolean}
     */
    _service.isInvalid = (data) => {
        var missingRequiredKeys = [];

        if (!data.person) {
            missingRequiredKeys.push('person.name');
            missingRequiredKeys.push('person.surname');
            missingRequiredKeys.push('person.email');
        }
        else {
            if (!data.person.name) {
                missingRequiredKeys.push('person.name');
            }
            if (!data.person.surname) {
                missingRequiredKeys.push('person.surname');
            }
            if (!data.person.email) {
                missingRequiredKeys.push('person.email');
            }
        }

        return missingRequiredKeys.length ? missingRequiredKeys : false;
    };

    /**
     * Load the given page with the given page size
     *
     * @param page_nr
     * @param page_size
     *
     * @return {Promise.<T>}
     */
    _service.loadPage = (page_nr = 0, params = {}, page_size = 20) => {
        const filter = angular.extend({use_cache: AppConstants.USE_CACHE}, params, {page_nr, page_size}),
            cachekey = JSON.stringify(filter);

        if (AppLanguage !== false) {
            filter.lang = AppLanguage.code;
        }

        if (!_pageCache[cachekey]) {
            _pageCache[cachekey] = CTServiceAPI.get(`/pages/${AppConstants.PAGE_ID}/commitments`, filter)
                .then((response) => {
                    var items = response.commitment_module_people.map((item) => CommitmentModelFactory(item));

                    if (AppConstants.RANDOMIZE) {
                        items = Array.shuffle(items);
                    }

                    delete _pageCache[cachekey];

                    if (Object.keys(params).length == 0) {
                        _unfilteredCommitments = _unfilteredCommitments.concat(items);
                    }

                    return {
                        items,
                        total_count: response.total_count
                    };
                });
        }

        return _pageCache[cachekey];
    };


    _service.getNextID = (forId) => $q((resolve, reject) => {
        function checkForId() {
            for (let index = 0; index < _unfilteredCommitments.length; index++) {
                if (_unfilteredCommitments[index].id == forId) {
                    if (_unfilteredCommitments[index + 1]) {
                        return resolve(_unfilteredCommitments[index + 1].id);
                    }
                }
            }
            reject()
        }

        setTimeout(checkForId, 0);
    });
    _service.getPreviousID = (forId) => $q((resolve, reject) => {
        function checkForId() {
            for (let index = _unfilteredCommitments.length - 1; index >= 0; index--) {
                if (_unfilteredCommitments[index].id == forId) {
                    if (_unfilteredCommitments[index - 1]) {
                        return resolve(_unfilteredCommitments[index - 1].id);
                    }
                }
            }
            reject();
        }

        setTimeout(checkForId, 0);
    });


    /**
     * Return a single item
     *
     * @param id
     */
    _service.get = (id) => {
        if (!_cachedCommitments[id]) {
            _cachedCommitments[id] = CTServiceAPI.get(`/pages/${AppConstants.PAGE_ID}/commitments/${id}`)
                .then((response) => CommitmentModelFactory(response.commitment_module_person));
        }

        return _cachedCommitments[id];
    };

    _service.totalCount = () => {
        return CTServiceAPI.get(`/pages/${AppConstants.PAGE_ID}/commitments`, {counter_only: 1})
            .then((data) => {
                if(Array.isArray(data.total_count)) {
                    let state_counter = data.total_count.filter((item) => item.state == 'released');

                    if(state_counter[0]) {
                        return state_counter[0].statecount;
                    }
                }
                else if(data.total_count) {
                    return data.total_count;
                }
            });
    };

    return _service;
}];
